<template>
  <div>
    <div v-if="form.type === 'procedure'" class="mb-4">
      <card title="Procedures">
        <label>Operations</label>
        <el-select
          v-model="form.operations"
          value-key="id"
          multiple
          filterable
          placeholder="Select operations..."
          no-data-text="No data"
          no-match-text="No match"
          style="width: 100%"
        >
          <el-option
            v-for="op in operations"
            :key="op.id"
            :label="catalogEntityLabel(op)"
            :value="op"
          />
        </el-select>
        <small class="text-muted d-block mt-2">Diagnostics are selected via Medical services.</small>
      </card>
    </div>

    <div v-if="form.type === 'illness'" class="mb-4">
      <card title="Illnesses">
        <label>Illnesses</label>
        <el-select
          v-model="form.illnesses"
          value-key="id"
          multiple
          filterable
          placeholder="Select illnesses..."
          no-data-text="No data"
          no-match-text="No match"
          style="width: 100%"
        >
          <el-option
            v-for="ill in illnesses"
            :key="ill.id"
            :label="catalogEntityLabel(ill)"
            :value="ill"
          />
        </el-select>
      </card>
    </div>
  </div>
</template>

<script>
export default {
  name: "OfferFormLinkedCatalog",
  props: {
    form: { type: Object, required: true },
    operations: { type: Array, required: true },
    illnesses: { type: Array, required: true },
    catalogEntityLabel: { type: Function, required: true }
  }
};
</script>
